/**
 * Pricing API request.
 *
 * @version 0.10.1
 * @author Ales Gabriel
 * @requires jquery
 * @copyright Avast Software s.r.o
 */

var Abdata = {
    cache : {},
    options: {
        pricelistApi: avastGlobals.web.RootPath + 'api/v2/pricing/business-pricelist?',
        pricelistApiB: avastGlobals.web.RootPath + 'api/v2/pricing/pricelist?',
        // These regions has prices with VAT
        vatLocales: {}
    },

    /**
     * init                     Merge options with defaults, build ajax pool and start ajax
     * @param  {Object} options Options
     * @return {Object}         Abdata instance
     */
    init: function(options){
        this.options = $.extend({}, this.options, options);
        this.cache = {};
        this.cacheDelimiter = ',';

        // Ajax pool
        if(typeof $.xhrPool === 'undefined'){
            $.xhrPool = [];

            $.xhrPool.abortAll = function() {
              $.each(this, function(idx, jqXHR) {
                    jqXHR.abort();
                });
            };
        }
        // initial price data
        this.getPriceData();

        return this;
    },

    /**
     * createCacheId                Generate cacheId
     * @param  {Object} parameters  InternalId and other data
     * @return {String}             Cache key
     */
    createCacheId: function(parameters){
        var elem = this.options.el,
            data = elem ? elem.data() : null,
            p = (parameters) ?  parameters : this.collectAjaxParams(data),
            _ = this.cacheDelimiter,
            cacheId;

            if (p.abtype === 'multiyear') {
                cacheId = p.internalId + '-' + p.campaign + _ + p.maintenance + _;
            } else {
                cacheId = p.internalId + '-' + p.campaign + _ + p.maintenance + _ + p.computers + _ + p.lic + _ + p.appendix;
            }

            return cacheId;
    },

    /**
     * getPriceData      Collect parameters and send AJAX request or read from cache.
     */
    // TODO: How about accept additional parameter here, which point to the element from which to collect AJAX params?
    getPriceData: function(el){
        var elem = el || this.options.el,
            data = elem ? elem.data() : null,
            params = this.ajaxParams = this.collectAjaxParams(data),
            priceLink = (params.abtype === 'multiyear') ? this.options.pricelistApi : this.options.pricelistApiB, // TODO : Update condition and path according to v2 API
            cacheId = this.createCacheId(params),
            priceData,
            paramQuery ='productId='    + params.internalId.match(/[^-]*-[^-]*/) +
                        '&internalId='  + params.internalId +
                        '&maintenance=' + params.multiyear +
                        '&seats='       + params.computers +
                        '&locale='      + avast.locale +
                        '&campaignMarker=' + params.campaignMarker +
                        '&platform=web' +
                        '&h='        + params.apiHash;

        if (params.installments) {
             paramQuery += '&installments=' + params.installments;
        }
        if (params.campaign) {
             paramQuery += '&campaign=' + params.campaign;
        }
        if (params.provider) {
             paramQuery += '&provider=' + params.provider;
        }

        // make ajax call
        //console.log("cacheId: %s", cacheId);
        //console.log("cache: %o", this.cache);

        if(!this.cache[cacheId]){
            $.ajax({
                type: "GET",
                url: priceLink + paramQuery,
                dataType: "json",
                context: this,
                beforeSend: function(jqXHR){
                    //$.xhrPool.abortAll(); // Kill all pending requests
                    $.xhrPool.push(jqXHR);
                },
                success: function(data){
                    this.parseData(cacheId, data);
                    priceData = this.selectFromCache(cacheId);
                    $(elem).trigger('data.ab.avast', [priceData ? 'data sent' : 'no data', priceData]);
                },
                error: function(jqXHR, textStatus, errorThrown){
                    if(textStatus !== "abort"){
                        $(elem).trigger('data.ab.avast', ['ajax error', textStatus, errorThrown]);
                    }
                }
            });
        } else {
          priceData = this.selectFromCache(cacheId);
          $(elem).trigger('data.ab.avast', [priceData ? 'data sent' : 'no data', priceData]);
        }
    },

    /**
     * collectAjaxParams    Read jQuery.data from element
     * data {Object}        parameters for AJAX request
     * @return {Object}     Ajax parameters
     */
    collectAjaxParams: function(data){
        var params = {};

        if(data){
            params = {
                abtype      :   (typeof data.abtype === 'string' && data.abtype.indexOf('business') > -1) ? 'multiyear' : '', // Can be solved only with different XML structure?
                internalId  :   data.internalid || '',
                campaign    :   data.campaign || '',
                maintenance :   data.maintenance || '12', // Maintenance should be skipped if multiyear is called
                computers   :   data.computers || '1',
                lic         :   data.lic || '1',
                appendix    :   '', // TODO: This polute cacheId with hypen on the end
                multiyear   :   data.multiyear || '12,24,36',
                provider    :   data.provider || null,
                installments:   data.installments || null,
                additional2 :   data.additional2 || null,
                apiHash :   data.apiHash || null,
                campaignMarker :   data.campaignMarker || 'WDS'
            };
        }
        return params;
    },

    /**
     * parseData                Convert data from AJAX response to object
     * @param  {String} cacheId Cache key
     * @param  {Object} data    JSON data
     */
    parseData: function(cacheId, data){
        // parsing should create
        var delim = this.cacheDelimiter,
            abDataInstance = this,
            re = new RegExp(this.cacheDelimiter + '(.+?)' + this.cacheDelimiter);

        /*
         * Update cache with new cacheId, put empty object as value.
         * If request is correct, it will be replaced with approp data.
         * Creating cacheId - even from incorrect ID - prevents calling AJAX requests repeatedly.
         */
        abDataInstance.updateCache(cacheId, {});

        if(data && !data.products) {
            // HOME
            $.each(data, function() {
                var cId = cacheId.replace(re, delim + this.maintenance + delim);

                this.maintenanceLimits = [12,24,36];
                this.computersLimits = [1, 3, 5, 10];
                this.priceInNumber = '' + this.price;
                this.price = this.priceFormatted;
                this.realPriceInNumber = '' + abDataInstance.stripDecimals(this.realPrice, this.precision);
                this.realPrice = this.realPriceFormatted;
                this.totalPrice = abDataInstance.getTotalPrice(this.internalId);

                abDataInstance.updateCache(cId, this);
            });
        } else if (data.products && data.products.length !== 0) {
            // BUSINESS
            $.each(data.products, function() {
                // Update cacheId
                var priceData = {};
                var price = [];
                var realPrice = [];
                var $this = $(this)[0];
                var cId = cacheId.replace(re, delim + $this.maintenance + delim);

                for (var key in $this.prices) {
                    price.push({
                        'min': parseInt(key, 10),
                        'price' : parseFloat($this.prices[key])
                      });
                      realPrice.push({
                        'min': parseInt(key, 10),
                        'price' : parseFloat($this.prices[key])
                      });
                }

                priceData.price = function(quant){
                    var _quant = parseInt(quant, 10),
                        _vat = (data.vat && abDataInstance.options.vatLocales[avast.locale]) ? data.vat : 1,
                        _price;

                    for (var i = 0; price.length > i; i++){
                        if(_quant >= price[i].min){
                            _price =  price[i].price;
                        }
                    }
                    return _price * _quant * _vat;
                };
                priceData.realPrice = function(quant){
                    var _quant = parseInt(quant, 10),
                        _vat = (data.vat && abDataInstance.options.vatLocales[avast.locale]) ? data.vat : 1,
                        _price;

                     for (var i = 0; realPrice.length > i; i++){
                        if(_quant >= realPrice[i].min){
                            _price = realPrice[i].price;
                        }
                    }
                    return _price * _quant * _vat;
                };
                priceData.link = function(quant){
                    return data.link.replace('{PID}', $this.foreignId).replace('{QUANT}', quant);
                };
                //priceData.discount = $this.attr('real-discount');
                priceData.flatDiscount = data.discount; // Flat discount not related to number of devices
                priceData.discountType = data.discountType;
                priceData.minQuantity = data.minQuantity;
                priceData.maxQuantity = data.maxQuantity;
                priceData.maintenance = $this.maintenance;
                priceData.maintenanceLimits = [12,24,36];
                priceData.priceFormat = data.priceFormat;
                priceData.currency = data.currencySymbol;
                priceData.thousandSeparator = data.thousandSeparator;
                priceData.decimalSeparator = data.decimalSeparator;
                priceData.precision = data.precision;
                priceData.priceFormat = data.priceFormat;

                abDataInstance.updateCache(cId, priceData);
            });
        } else {
            var msg = 'no data';
            $(elem).trigger('data.ab.avast', [msg]);
        }
    },

    /**
     * stripDecimals Remove additional decimals over precision limit
     * @param  {number} number    A number to be stripped
     * @param  {integer} precision Number of decimals in returned float
     * @return {number}           Stripped number
     */
   stripDecimals: function(number, precision){
        var decimalSeparator = '\\.',
            regex = new RegExp("^-?\\d+(?:" + decimalSeparator + "\\d{0," + precision + "})?");

        if (precision) {
            number = number.toString().match(regex)[0];
        }

        return Number(number);
    },

    /**
     * updateCache                  Store data in cache to specific key
     * @param  {String} cacheId     Cache key
     * @param  {Object} data        Price data
     */
    updateCache: function(cacheId, data){
        this.cache[cacheId] = data;
    },

    /**
     * Get price data from cache
     * @param  {String} cacheId Unique identifier. Look to createCacheId method from what is created.
     * @return {Object} Price data
     */
    selectFromCache : function(cacheId){
        return this.cache[cacheId];
    },

    /**
     * getDataByInternalId         Select all matched entries in cache. Match can be partial.
     * @param  {String} internalId Internal ID of product
     * @param  {Object} props      Additional properties which can modify cache ID identificator (campaign, maintenance, pcs, etc.)
     * @return {Array}            Price objects
     */
    getDataByInternalId  : function(internalId, props){
        var cache = this.cache,
            params = $.extend({}, {internalId: internalId}, props),
            ajaxParams = this.collectAjaxParams(params),
            cacheId = this.createCacheId(ajaxParams),
            cacheData = this.selectFromCache(cacheId),
            re = new RegExp('^' + internalId),
            data = [];

        if(props) {
            if(cacheData){
                data.push(cacheData);
            }
        } else {
            for(var key in cache){
                // console.log('Match: %s', re.test(key))
                if(re.test(key)) {
                    data.push(cache[key]);
                }
            }
        }

        return data;
    },
    /**
     * getTotalPrice Collect prices from data attributes.
     * @description Method assumes there is a `data-pricelist` attribute in the markup 
     * with prices without installment divider. Pricelist should expose all seats prices for maintenance variant.
     * @param  {string} id InternalId
     * @return {string}    Price
     */
    getTotalPrice: function(id) {
        var price = null;

        $('[data-pricelist]').each(function(index) {
            var priceList;

            try {
                priceList = JSON.parse(this.dataset.pricelist);
            } catch(error) {
                console.log(error);
            }

            if (priceList && priceList[id]) {
                price = priceList[id].realPriceFormatted;
            }
        });

        return price;
    }
};

/**
 * Actionbox object: Product Actionbox with prerendered prices.
 *
 * @version 0.4.0
 * @author Ales Gabriel
 * @copyright Avast Software s.r.o &copy;2016
 * @requires src/j/producthome/product-home-abdata.js
 *
 */

var Actionbox = {
    defaults: {
       abProductsSelector   : '[data-internalid]', // Context element selector
       overlaySelector      : '#overlay', // Dim page with this element.
       abBoxSelector        : '.box', // boxes class 
       autoLoadData         : false, // Request AJAX price data with first render. It will rewrite prices, links which are set in html  
       installments         : 0,
       installmentTemplate  : '',
       customCurrency       : '',
       currencySwitch       : ''
    },
    /**
     * Init plugin and register global listeners
     * @param  {Object}     opts    Config options
     * @param  {DOM Node}   elem    Element where plugin is initiated            
     */
    init: function(opts, elem){
         this.options = $.extend({},this.defaults,opts);
         this.build(elem);

         // Register default events
         $(document).on('data.ab.avast', $.proxy(this.loopBoxes, this));
    },
    /**
     * Register UI events, open and call for price data
     * @param  {Event}  evt    Event called for popup    
     */
    build: function(elem){
        // Count timeout
        this.countTimeout = '';

        // If custom template replace default popup with different element
        this.context = $(elem);
        // abEl can be in elements on which actionbox is initialized, but must have data-internalid set. 
        // Or can be any first-child with data-internalid set.
        this.abEl = this.context.data('internalid') ? this.context : this.context.find('[data-internalid]').first();

        // Prerender
        this.preRender();
        
        // Register close events        
        $(document).on('keydown.ab.avast', $.proxy(this.handleKeyPress, this));

        // Register button events
        this.abEl.find('.add:not(.disabled)').on('mousedown.ab.avast', $.proxy(this.updateInputs, this));
        this.abEl.find('.add:not(.disabled)').on('mouseup.ab.avast', $.proxy(this.updateInputsData, this));

        // Only if it is autoLoadData ask for data during with build. Otherwise wait for user interaction. 
        if(this.options.autoLoadData){
            this.pullData();
        }
    },
    /**
     * Correct display, reset inputs.
     */
    preRender : function() {
        // Prerender
        this.abEl.append('<div class="ab-overlay hidden" />');
        this.resetInputs();
        var boxClass = this.options.abBoxSelector;

        // Hide Regular price label if price missing or price is same as price. 
        this.abEl.find('.no-discount').each(function(){
            var $this = $(this),
                box = $this.closest(boxClass),
                valEl  = $this.find('.value'),
                valContent = valEl.text(),
                isEmpty = !$.trim(valContent),
                priceEqual = ($(box).find('a.button > span').text() === valContent ) ? 1 : 0;
            
            if(isEmpty || priceEqual) {
                $this.addClass('hidden');
            }
        });

        // Disable selector plus/minus buttons if there is only one PC option to select
        if(this.abEl.data('computers-limits') && this.abEl.data('computers-limits').length === 1){
            this.abEl.find('.select .add').addClass('disabled');            
        }
    },
    /**
     * pullData Ask for data 
     * @return {[type]} [description]
     */
    pullData: function(){
        var opts = this.options || {}
        // DOM changes - Add spinner
        // TODO: move to own function 
        this.abEl.addClass('spinning');
        this.abEl.find('.box .button').addClass('spinning');
        this.abEl.parent('div').find('.ab-overlay').removeClass('hidden');

        // Ask for data. 
        if($.data(this.abEl.get(0), 'abdata')){
            this.abEl.data('abdata').getPriceData();
        } else {
            // If no instance of abdata on element, revoke abdata plugin initialization.
            if(typeof $.fn.abdata === 'function'){
                opts.el = this.abEl;
                this.abEl.abdata(opts);
            }
        }
    },
    /**
     * loopBoxes Incrementaly loop boxes, create specific cacheId and call for price data update.
     * @param  {Event} evt      Internal data.ab.avast event
     * @param  {String} msg     Message from event
     * @param  {Object} data    Prices, links, formats etc.
     */
    loopBoxes: function(evt, msg, data){

        var nextInternalId,
            nextBox;

        if(data && data.maintenance) {
            var root = this;
            // load prices, links etc. to current box
            this.fillData(evt, msg, data);
            // TODO: Try harder to indentify next box.
            // This doesn't work if some maintanence box is missing ... check siblings in DOM or something like this
            // Prepare next maintenance
            this.abEl.data('maintenance', parseInt(data.maintenance, 10) + 12);
            
            nextBox = this.abEl.find('[data-internalid]').filter(function(){
                var boxInternalId = $(this).data('internalid');
                var nextInternalId = root.buildInternalId(boxInternalId, {maintenance: parseInt(data.maintenance, 10) + 12});

                var boxInternalIdObj = root.internalIdToObj(boxInternalId);
                var currentMaintenance = boxInternalIdObj.maintenance;
                var nextMaintenance = parseInt(data.maintenance, 10) + 12;
    
                // return $(this).data('internalid') === nextInternalId;
                return parseInt(currentMaintenance, 10) === nextMaintenance;
            });

            if($.data(this.abEl.get(0), 'abdata') && nextBox.length > 0){
               // Ask for data only if next box exists
               this.pullData();
            } else {
               // Publish price update is finished
               
               $(document).trigger('priceUpdate.ab.avast', ['actionbox prices updated']);
            }
            this.abEl.removeData('maintenance');
        }
    },

    /**
     * fillData  Update DOM with data
     * @param  {Event} evt      Internal data.ab.avast event
     * @param  {String} msg     Message from event
     * @param  {Object} data    Prices, links, formats etc. 
     */
    // TODO: Last param should be last.
    fillData: function(evt, msg, data) {
        var formatedData = {},
            pcs = this.abEl.find('#computers'),
            mainInternalId = this.abEl.data('internalid'),
            root = this,
            itemInternalId,
            context,
            priceDivider = (this.options.pricing === 'monthly' && data && data.maintenance) ? data.maintenance : 1,
            currencySymbol = data.currencySymbol ? data.currencySymbol : data.currency;

        if (data){
            // Reduce input values to min/max if set.
            if(data.minQuantity){
                if(parseInt(pcs.val(), 10) <= parseInt(data.minQuantity, 10)) {
                    pcs.val(data.minQuantity);
                }
            }
            if(data.maxQuantity){
                if(parseInt(pcs.val(), 10) >= parseInt(data.maxQuantity, 10)){
                    pcs.val(data.maxQuantity);
                }
            }

            // TODO: Where to triger validation message HAS_PRICE = 1

            // Computers quantity in input
            var quant = pcs.val();

            // Prices
            formatedData.link = (typeof data.link === 'function') ? data.link(quant) : data.link;
            formatedData.realPrice = (typeof data.realPrice === 'function') ? data.realPrice(quant) : data.realPrice;
            formatedData.price = (typeof data.price === 'function') ? data.price(quant) : data.price;
            formatedData.discount = data.discount;
            formatedData.totalPrice = data.totalPrice;
            formatedData.seats = pcs.val();

            // Formating prices
            if(typeof data.price === 'function'){
                formatedData.price = this.formatPrice(formatedData.price, data.priceFormat, data.currency, data.precision, data.decimalSeparator, data.thousandSeparator);
                formatedData.realPrice = this.formatPrice(formatedData.realPrice, data.priceFormat, data.currency, data.precision, data.decimalSeparator, data.thousandSeparator);
            }

            // Formating installments prices
            if(this.options.installments){
                var installmentPrice = this.formatPrice((data.realPriceInNumber) , data.priceFormat, currencySymbol, data.precision, data.decimalSeparator, data.thousandSeparator);
                formatedData.realPriceTotal = formatedData.realPrice;
                formatedData.realPrice = this.options.installmentTemplate.replace('#p', this.options.installments) + installmentPrice;
            }

            if(this.options.priceyTypo){
                var typoPrice = this.formatPrice((data.realPriceInNumber / priceDivider) , data.priceFormat, currencySymbol, data.precision, data.decimalSeparator, data.thousandSeparator);
                typoPrice = typoPrice.replace('&nbsp;', '');

                var typoPriceParts = typoPrice.split(data.decimalSeparator);
                var markupPrice = [];
                
                // Open price wrapper
                markupPrice.push('<span class="price-wrapper">');
                // Paste currency before price
                if(typoPrice.indexOf(currencySymbol) === 0){
                     markupPrice.push('<span class="currency">' + currencySymbol + '</span>');
                }
                // Paste price
                markupPrice.push('<span class="integer">' + typoPriceParts[0].replace(currencySymbol, '') + '</span>');
                
                // Decimal price if any
                if(typoPriceParts[1]){
                    markupPrice.push('<span class="decimal">' + data.decimalSeparator + typoPriceParts[1].replace(currencySymbol, '') + '</span>');
                } 
                // Paste currency symbol after price   
                if(typoPrice.indexOf(currencySymbol) !== 0){
                     markupPrice.push('<span class="currency">' + currencySymbol + '</span>');
                }
                // Close price wrapper
                markupPrice.push('</span>');
                
                formatedData.realPriceTotal = formatedData.realPrice;
                formatedData.realPrice = markupPrice.join('');
            }

            if(this.options.pricing === 'monthly'){
                formatedData.link = formatedData.link.replace(/\/CustomID.(.*?)\//, '/CustomID.' + this.options.customId + '/');
            }

            // Set only data values, leave DOM data attributes without change.
            if(data.computersLimits && !this.abEl.data('computers-limits')){
                this.abEl.data('computers-limits', data.computersLimits);
            }
            if(data.maintenanceLimits && !this.abEl.data('maintenance-limits')){
                this.abEl.data('maintenance-limits', data.maintenanceLimits);
            }
            if(data.minQuantity){
                this.abEl.data('min-quantity', data.minQuantity);
            }
            if(data.maxQuantity){
                this.abEl.data('max-quantity', data.maxQuantity);
            }
            
            if(data.maintenance && mainInternalId){
                itemInternalId = this.buildInternalId( mainInternalId, {maintenance: parseInt(data.maintenance, 10)});
                // Get context element by comparing maintenance in internalId for each box and data.maintenance 
                context = this.abEl.find('[data-internalid]').filter(function(){
                        var boxInternalId = $(this).data('internalid'),
                            boxInternalIdObj = root.internalIdToObj(boxInternalId),
                            currentMaintenance = boxInternalIdObj.maintenance,
                            nextMaintenance = parseInt(data.maintenance, 10);

                        return parseInt(currentMaintenance, 10) === nextMaintenance;
                    });
            }
            
            if(context){
                this.renderData(context, formatedData);
            }
        }
    },
    /**
     * renderData Update DOM with changes
     * @param  {DOMElement} context         Ancestor element
     * @param  {Object}     formatedData    Data to render
     */
    renderData: function(context, formatedData){
            // Render prices and link values
            this.renderValue('.button > span', context, formatedData.realPrice);
            this.renderValue('.discounted > span:first-child', context, formatedData.realPrice);
            this.renderValue('.discount', context, formatedData.realPriceTotal);
            this.renderValue('.no-discount', context, (formatedData.discount) ? formatedData.price : '');
            this.renderValue('.save', context, formatedData.discount);
            this.renderValue('.button', context, formatedData.link, 'href');
            this.renderValue('.cart', context, formatedData.link, 'href');
            this.abEl.removeClass('spinning');
            this.abEl.find('.box .button').removeClass('spinning');
            this.abEl.find('.ab-overlay').addClass('hidden');
            this.renderValue('.no-installments', context, (formatedData.totalPrice ? formatedData.totalPrice : ''));
            this.renderValue('.cart', context, formatedData.seats, 'data-seats');
    },
    //WUT
    /**
     * formatPrice Format price with currency, correct precision, decimal thousand separator and currency
     * @param  {[type]} price       [description]
     * @param  {[type]} priceFormat [description]
     * @param  {[type]} currency    [description]
     * @param  {[type]} precision   [description]
     * @param  {[type]} decSep      [description]
     * @param  {[type]} thSep       [description]
     * @return {String}             Price with correct format with currency
     */
    formatPrice: function(price, priceFormat, currency, precision, decSep, thSep){
        var formatedPrice;

        if(typeof $().number_format === 'function') {
            formatedPrice = $().number_format(price,
                            {
                                numberOfDecimals: precision,
                                decimalSeparator: decSep,
                                thousandSeparator: thSep,
                                symbol: ""
                            });
        }
        if(formatedPrice){
            return priceFormat.replace("#c",currency).replace("#p",formatedPrice);
        }
    },
    /**
     * renderValue Output specific value to DOM. If Element has child with css class ".value", value will be rendered in this child.   
     * @param  {[type]}     cssSelector     Element selector
     * @param  {DOMElement} context         Search for cssSelector in specified context 
     * @param  {String}     val             Value 
     * @param  {String}     attr            Load value to element attribute
     */
    renderValue: function(cssSelector, context, val, attr){
        var elem = (cssSelector) ? $(context).find(cssSelector) : '';
        if(val){
            elem.removeClass('hidden');
            // Update attributes 
            if (attr && attr !== 'class') {
                elem.attr(attr, val);
            } else if (attr && attr === 'class'){
                elem.removeClass(this.findClass(elem, 'avast-').join(''));
                elem.addClass(val);
            } else {
                if(elem.has('.value').length > 0){
                    elem.find('.value').html(val);
                } else {
                    elem.html(val);
                }
            }
        } else {
            elem.addClass('hidden');
        }
    },
    /**
     * [updateInputsData description]
     * @param  {Event} evt Mouse event when encrease, decrease pcs or maintenance  
     */
    updateInputsData: function(evt) {
        var pcs = this.abEl.find('#computers'),
            yrs = this.abEl.find('#maintenance'),
            current = ($(evt.currentTarget).siblings('.amount').find('#computers').length > 0) ? pcs : yrs,
            newVal = parseInt(current.val(), 10), // TODO: value based on minQuantity, maxQuantity
            newIndex,
            pcsString = this.pad(pcs.val(), 3),
            btn = $(evt.currentTarget);

        // Break if custom behavior
        if(btn.data('behavior') === 'custom'){
            return;
        }

        // Stop event input updates.
        clearTimeout(this.countTimeout);

        
        if(current === yrs){
            if(parseInt(newVal, 10) >= 12){
                // Convert months to years
                newVal = parseInt(newVal, 10) / 12;
            } else {
                // Months are not currently in use.
            }
        }

        // Update data with value from input      
        this.abEl.data('computers', pcs.val());
        
        // Inputs and data config done. Call for prices.
        if(evt.type === 'mouseup' || (evt.type === 'mouseout' && btn.data('flag-outbound') === 'mouseout')){
            btn.removeData('flag-outbound');
            $(document).trigger('quantityChange.avast:ab');
            this.updateInternalIds({pcs: pcsString});
            this.pullData();
        }
    },
    //WUT
    /**
     * pad Leading zeros
     * @param  {Number} num  Number to which add leading zeros
     * @param  {Number} size From what size prepend zeros
     * @return {String}      [description]
     */
    pad: function(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    },
    /**
     * updateInternalIds        Loop elements with data-internalid attribute and update its internalId.  
     * @param  {Objec} props    Properties to be updated ( Available props: name | version | pcs | maintenance | renewal )
     */
    updateInternalIds: function(props){
        var root = this;

        /** 
          * There must be internalId updated for home.
          * But mustn't be updated for business.
          */
        var context = (this.abEl.data('abtype') !== 'business') ? this.abEl.parent() : this.abEl;

        context.find('[data-internalid]').each(function(){
            var $this = $(this);
            var newId = root.buildInternalId($this.data('internalid'), props);
            $this.data('internalid', newId);
        });
    },

    //WUT
    /**
     * buildInternalId Build new internal ID by merge former internalid and props from parameter
     * @param  {String} id    Internal ID to update 
     * @param  {Object} props Properties to be updated ( Available props: name | version | pcs | maintenance | renewal )
     * @return {String}       New Internal ID
     */
    buildInternalId: function(id, props){
        var newId,
            idObj = this.internalIdToObj(id),
            _idObj = {};
        if(props){
            $.extend(_idObj, idObj, props);
        }
        newId = $.map(_idObj, function(prop){return prop;}).join('-');
        
        return newId;
    },

    //WUT
    /**
     * internalIdToObj description
     * @param  {String} internalId Internal ID (eg. ISE-08-001-12-MR).
     * @return {Object}            Internal ID converted to object
     */
    internalIdToObj: function(internalId){
        var idObj = {},
            idParts = internalId.split('-');

        // TODO: This one only works for new internalId strings format (eg. ISE-08-001-12-MR). 
        idObj.name = idParts[0];
        idObj.version = idParts[1];
        idObj.pcs = idParts[2];
        idObj.maintenance = idParts[3];
        idObj.renewal = idParts[4];

        return idObj;
    },

    /**
     * resetInputs Set elements data to default values PCs: 1, Maintenance: 12
     */
    resetInputs: function(){
        var pcs = this.abEl.find('#computers'),
            yrs = this.abEl.find('#maintenance'),
            prodEl = this.abEl;

        pcs.val(1);
        yrs.val(1);

        // Change data
        prodEl.data('computers', 1);
        prodEl.data('maintenance', 12);
        if(prodEl.data('internalid-default')){
            prodEl.data('internalid', prodEl.data('internalid-default'));
        }

        // Enable disabled buttons
        this.abEl.find('.add.disabled').removeClass('disabled');
    },
    //WUT
    /**
     * findClass Find class by prefix
     * @param  {DOMElement} el          In Element
     * @param  {String}     prefix      Search for prefix 
     * @return {Boolean}                
     */
    findClass: function(el, prefix) {
        var classes = $(el).attr("class").split(" ").filter(function(c) {
            return c.lastIndexOf(prefix, 0) === 0;
        });
        return classes;
    },
    //WUT
    /**
     * allowedValues Return allowed values in selector. Limits higher importance over min, max 
     * @param  {Number} min     Minimal value
     * @param  {Number} max     Maximal value
     * @param  {Array} limits   Ordering has holes - send exact values in Array
     * @return {Array}
     */
    allowedValues: function(min, max, limits){
        var values = [],
            len = (min && max) ? max - min + 1 : false;

        if(!limits && len){
            for(var i = 0; len > i; i++){
                values.push(min + i);
            }
        } else {
            values = limits;
        }
        return values;
    },

    /**
     * updateInputs Button click handler. Manage increase/decrease on inputs and update data attributes
     * @param  {Event} evt Mouse event
     */
    updateInputs: function(evt){
        var btn = $(evt.currentTarget),
                  speed = 300, // Initial speed of counting
                  speedup = 0.5, // next loop will be shorter then previous about this amount
                  maxSpeed = 50, // max speed in which counting is repeated (in miliseconds)                 
                  root = this,
                  inputId = btn.closest('.select').find('input').attr('id'),
                  input = this.abEl.find('#' + inputId),
                  increase = (btn.hasClass('plus')) ? 1 : -1;


        var min = parseInt(this.abEl.data('min-quantity'), 10),
            max = parseInt(this.abEl.data('max-quantity'), 10),
            limits = (inputId === 'computers') ? this.abEl.data('computers-limits') : this.abEl.data('maintenance-limits'),
            // Create array from min max, or limits.
            values = this.allowedValues(min, max, limits);

        // Break if custom behavior
        if($(evt.currentTarget).hasClass('disabled')){
            return;
        }
        
        if(typeof evt.originalEvent.preventDefault === "function"){
            evt.originalEvent.preventDefault(); // Disable Chrome set cursor to text while dragging
        }

        if(values) {
            maxSpeed = 150; // Slowdown max speed if values are limited. 
            this.countIndex = values.indexOf((inputId === 'computers') ? parseInt(input.val(), 10) : parseInt(input.val(), 10) * 12);
        } else {
            this.countIndex = (inputId === 'computers') ? parseInt(input.val(), 10) : parseInt(input.val(), 10) * 12;
        }

        // bind/unbind mouseout event on each attempt
        if (btn.data('flag-outbound') !== 'mouseout'){
                btn.on('mouseout.ab.avast', function(evt){
                    clearTimeout(root.countTimeout);
                    root.updateInputsData.call(root, evt);
                    btn.off('mouseout.ab.avast');
                    btn.removeData('flag-outbound');
                });
            btn.data('flag-outbound', 'mouseout');
        }

        counting(function(){
            root.updateCount(values, root.countIndex, inputId, increase, min, max);
        });

        // Update speed of incrementing 
        function counting(fn){
            fn();
            root.countTimeout = setTimeout(function(){counting(fn);}, speed);
            speed = (speed > maxSpeed) ? speed * speedup : maxSpeed;
        }
    },
    /**
     * updateCount Make changes to DOM data attributes and input values on each counting step
     * @param  {Array}  values     Array of allowed values, which can be dispalyed in selector
     * @param  {Integer} countIndex Index of allowed value, which have to be displayed
     * @param  {String} inputId    Identify which selector should be updated
     * @param  {Integer} increase   1|-1
     */
    updateCount: function(values, countIndex, inputId, increase, min, max){
        var msg;
        // Counting in virtual steps
        if(values){
            if((countIndex + increase) >= 0  &&  (countIndex + increase) < values.length){
                this.countIndex = countIndex + increase;
            } else {
                msg = (countIndex === 0) ? 4 : 3;
                if(msg === 4) {
                    this.countIndex = values.length - 1;
                }
                if (msg === 3) {
                    this.countIndex = 0;
                }
            }
            this.abEl.find('#' + inputId).val((inputId === 'computers') ? values[this.countIndex] : values[this.countIndex] / 12);
        // Plain increment
        } else {
            var input = this.abEl.find('#' + inputId);
            var count = parseInt(input.val(), 10) + increase;
            // TODO: check why stops working if counting under zero !!
            if(count > 0){
                input.val(count);
            }
            if(count > max ) {
                msg = 3;
            }
            if(count <= min ) {
                msg = 4;
            }
        }
        // Triger validation message here TOO_MANY = 3, TOO_SMALL = 4. and decide what to do
        // TODO: Can be performance expensive to trigger event here.
        // On the other hand this is the right place to publish message, that limit was reached, buttons can be disabled and so.
        // Other solution could be set min, max variables besides limits and check it only when user release mouse 
        // But it should looks wierd to count in different steps  until limit is reached and then follow with incrementing by 1.
        if(msg){
            this.triggerMsg('validation.avast', msg);
        }
    },
    _clearTimeout: function(){
        clearTimeout(this.countTimeout);
    },
    /**
     * triggerMsg Publish event on document 
     * @param  {String} type Event type
     * @param  {String} msg  Event message
     */
    triggerMsg: function (type, msg){
        $(document).trigger(type, [{message: msg}]);
    },
    /**
     * updatePrice  Facade code for $('#abox-home-boxes').ab('updatePrice');
     * @return {[type]} [description]
     */
    updatePrice: function (){
        var opts = this.options || {};
        if(typeof $.fn.abdata === 'function'){
            opts.el = this.abEl;
            this.abEl.abdata(opts);
        }
        // TODO !!! or use this.pullData();
    }
};

///////////////////////////////////////////////////////////////////

// Array.prototype.filter polyfill
if (!Array.prototype.filter)
{
  Array.prototype.filter = function(fun /*, thisArg */) {

    if (this === void 0 || this === null)
      throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function")
      throw new TypeError();

    var res = [];
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      if (i in t)
      {
        var val = t[i];
        
        if (fun.call(thisArg, val, i, t))
          res.push(val);
      }
    }

    return res;
  };
}

// Array.prototype.indexOf polyfill
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
      if ( this === undefined || this === null ) {
        throw new TypeError( '"this" is null or not defined' );
      }

      var length = this.length >>> 0; // Hack to convert object.length to a UInt32

      fromIndex = +fromIndex || 0;

      if (Math.abs(fromIndex) === Infinity) {
        fromIndex = 0;
      }

      if (fromIndex < 0) {
        fromIndex += length;
        if (fromIndex < 0) {
          fromIndex = 0;
        }
      }

      for (;fromIndex < length; fromIndex++) {
        if (this[fromIndex] === searchElement) {
          return fromIndex;
        }
      }

      return -1;
    };
}

// Object create
if (typeof Object.create !== 'function') {
    Object.create = function (obj) {
        function F(){}
        F.prototype = obj;
        return new F();
    };
}

// Init Abdata and actionbox jQuery plugins
$(document).ready(function() {

    // Enable popup actionboxes
    $.fn.ab = $.fn.actionbox = function(options){
        if (this.length > 0) {
            if(Actionbox[options] && $(this).data('actionbox')){
                // TODO: support legacy code $('#abox-home-boxes').ab('updatePrice');                
                $(this).data('actionbox')[options].apply($(this).data('actionbox'));
                return;
            }
            if(typeof options === 'object' || !options){
                return this.each(function(){
                    var actionbox = Object.create(Actionbox);
                    actionbox.init(options, this);

                    $.data(this, 'actionbox', actionbox);
                });
            }
        }
    };

    // Load price data plugin
    $.fn.abdata = function(options){
        if (this.length > 0) {
            return this.each(function(){
                var abdata = Object.create(Abdata);
                abdata.init(options);

                $.data(this, 'abdata', abdata);
            });
        }
    };

    
    // Init actionbox
    // Call directly on actionbox wrapper ->  $('#abox-home-boxes-v10').actionbox() and find #main internally.
    // Actually do not rely on #main, but look for the first element with data-internalid attribute set. 
    // Sken not only childs but also root element itself for data-internalid attribute.
    var abconfig = {};

    if($('#abox-home-color-v10').length > 0){
        abconfig.priceyTypo = true;
    }

    if($('#abox-home-color-v10 [data-pricing="monthly"]').length > 0){
        abconfig.priceyTypo = true;
        abconfig.pricing = 'monthly';
        abconfig.customId = 'PPMONTH';
    }

    if(locale === 'pt-br'){
        abconfig.installments = 3;
        abconfig.priceyTypo = false;
    }

    // Init actionboxes
    // Standard actionbox
    $('#abox-home-boxes-v10').actionbox(abconfig);
    // actionbox 2015
    $('#abox-home-color-v10').actionbox(abconfig);
});

/**
 * PRODUCT HOME COMMON
 */

 // Top height
function detectInitScreen(){
    var scrn = (window.getComputedStyle) ? window.getComputedStyle(document.body,':after').getPropertyValue('content') : '';
    return scrn;
}
function setStickyHeight() {
    var screenSize = detectInitScreen();
    var stickyHeight = 72;
    if (screenSize == 'mobile'){
        stickyHeight = 0;
    }
    if (screenSize == 'tablet') {
        stickyHeight = 0;
    }
    return stickyHeight;
}

$(document).ready(function() {
    var osVer = sysReqOsVer();
    
    if(!osVer){
        $('#sysreq .supported').hide();
        $('#sysreq .not-supported').show();
    }
    // toggle sysreq     
    $('.sysreq-toggle-link').on('click', function(e){
        e.preventDefault();
        var sysreq = $('#sysreq');
        var sh = sysreq.outerHeight();
        var h = sh - $('#sysreq .supported').outerHeight() + $('#sysreq .not-supported').height();
        
        sysreq.css({'min-height' :  sh + 'px'});
        sysreq.animate({'min-height' : h}, 200);
        $('#sysreq .supported').fadeOut(300, function(){
            $('#sysreq .not-supported').fadeIn(300);
        });
    });

    if(osVer){
        $('#sysreq .sysreq-os-ver').text(osVer);
    }
});


function sysReqOsVer(){
    var ua = navigator.userAgent.toLowerCase();
    var supportedVersions = ['XP', 'Vista', '7', '8', '10'];
    var version;
    var detect = avm.require('avast.detect')();

    if(typeof detect === 'object' && detect.os.isWindows){
        for(var i = 0; supportedVersions.length > i; i++){
            if(detect.os.version === supportedVersions[i]){
                version = detect.os.name + ' ' + detect.os.version;
            }
        }
    }
    
    if(ua.indexOf(' arm;') > -1){
        return false;
    }

    return version;
}

// Custom function for animation on page
(function () {
    'use strict';
    var jsExpandLinkSpan = $('.js-expand-link span');
    jsExpandLinkSpan.on('click', function () {
        var selfParent = $(this).parent(),
            nextExpandBox = selfParent.nextAll('.js-expand-box');
        if (selfParent.hasClass('active')) {
            selfParent.removeClass('active');
            nextExpandBox.first().slideUp();
        } else {
            selfParent.addClass('active');
            nextExpandBox.first().slideDown();
        }
    });
})();

// FIX WCS-1003: Show price without discount if differs from discounted price
(function () {
    'use strict';

    $('.box[data-internalid]').each(function(i){
        var box = $(this),
            numberPattern = /\d+/g,
            discount = box.find('.discounted'),
            divider = box.find('.divider'),
            noDiscount = box.find('.no-discount'),
            discountText = divider.text() + discount.text(),
            noDiscountText = noDiscount.text(),
            discountPrice = discountText ? discountText.match(numberPattern) : null,
            noDiscountPrice = noDiscountText ? noDiscountText.match(numberPattern) : null;

        if(discountPrice && noDiscountPrice){
            if(discountPrice.join('') !== noDiscountPrice.join('')){
                noDiscount.removeClass('hidden');
            }
        }
    });
})();
